import myProfileUrls from '../myProfileUrls'
import CreateAccountButton from './CreateAccountButton'
import LoginButton from './LoginButton'
import LogoutButton from './LogoutButton'
import { MenuItem } from './MenuItem'
interface Props {
  locale: string
  disabled: boolean
  content: {
    MY_PROFILE: string
    MENU_ONE_TITLE: string
    MENU_TWO_TITLE: string
    MENU_THREE_TITLE: string
    LOGIN: string
    LOGOUT: string
    CREATE_NEW_ACCOUNT: string
    FIRST_TIME_HERE: string
  }
  onCreateAccountClicked: () => void
  onLoginClicked: () => void
  onLogoutClicked: () => void
}

export const Menu: React.FC<Props> = ({ locale, disabled, content, onCreateAccountClicked, onLoginClicked, onLogoutClicked }) => {
  return (
    <div
      id="login-menu"
      className="login-bg-dfds-surface-light login-z-overlay mobile:login-fixed md:login-absolute login-top-[50px] mobile:login-left-4 login-right-4 md:login-min-w-[350px] login-shadow-xl login-rounded-lg"
    >
      <div className="login-leading-[28px] login-bg-dfds-primary-primary login-flex login-items-center login-p-dfds-s login-border-0 login-border-b login-border-solid login-border-dfds-divider-dark login-rounded-t-lg">
        <div className="login-dfds-small-headline login-text-dfds-text-light-primary">{content.MY_PROFILE}</div>
      </div>
      <MenuItem dataE2eAttr="MENU-ONE" disabled={disabled} href={getPageUrl(locale, 'profile')} title={content.MENU_ONE_TITLE} />
      <MenuItem dataE2eAttr="MENU-TWO" disabled={disabled} href={getPageUrl(locale, 'bookings')} title={content.MENU_TWO_TITLE} />
      <MenuItem dataE2eAttr="MENU-THREE" disabled={disabled} href={getPageUrl(locale, 'consent')} title={content.MENU_THREE_TITLE} />
      {disabled ? (
        <div className="login-flex login-flex-col login-items-center login-px-dfds-s login-pt-dfds-s login-rounded-b-lg">
          <LoginButton text={content.LOGIN} onClicked={onLoginClicked} />
          <CreateAccountButton text={content.CREATE_NEW_ACCOUNT} explainer={content.FIRST_TIME_HERE} onClicked={onCreateAccountClicked} />
        </div>
      ) : (
        <div className="login-flex login-flex-col login-items-center login-p-dfds-s login-rounded-b-lg">
          <LogoutButton text={content.LOGOUT} onClicked={onLogoutClicked} />
        </div>
      )}
    </div>
  )
}

const getPageUrl = (locale: string, pageType: 'profile' | 'consent' | 'bookings') => {
  const url = myProfileUrls.find((url) => url.locales.includes(locale))
  return url ? `/${locale}/${url.ferryAccount}/${url[pageType]}${pageType === 'bookings' ? '?show=5' : ''}` : ''
}
